var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, Card, CardActionArea, CardContent, Typography, } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
export var LeagueCard = function (_a) {
    var _b;
    var league = _a.league;
    var MAX_LENGTH = 120;
    var _c = __read(useState(false), 2), expanded = _c[0], setExpanded = _c[1];
    var description = league.description || "";
    var isLong = description.length > MAX_LENGTH;
    var shownDescription = !isLong || expanded
        ? description
        : description.slice(0, MAX_LENGTH).trimEnd() + "…";
    return (_jsx(Card, { children: _jsx(CardActionArea, { component: Link, to: "/leagues/".concat(league.id, "/"), children: _jsxs(CardContent, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [_jsx(Avatar, { alt: league.name, src: league.logo || undefined, sx: { width: 56, height: 56 }, children: (_b = league.name.match(/\b(\w)/g)) === null || _b === void 0 ? void 0 : _b.join("") }), _jsxs("div", { children: [_jsx(Typography, { variant: "h6", children: league.name }), description && (_jsxs(Typography, { variant: "body2", color: "text.secondary", component: "div", children: [shownDescription, isLong && (_jsx(Button, { size: "small", color: "primary", onClick: function (e) {
                                            e.preventDefault(); // prevent link navigation when toggling
                                            setExpanded(function (prev) { return !prev; });
                                        }, sx: {
                                            ml: 1,
                                            textTransform: "none",
                                            padding: 0,
                                            minWidth: "auto",
                                        }, children: expanded ? "Show less" : "Read more" }))] }))] })] }) }) }));
};
